export default __webpack_public_path__ + "static/media/flag-zh-TW.f4cc02f5.svg";